import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { InsuranceData } from "../../interfaces/DTO/insurance_data/InsuranceData";
import { insuranceDataService } from "../../services/insurance_data/InsuranceDataService";
import { createCachedEntityHooks } from "../createEntityHooks";

export const {
  useAll: useInsuranceData,
  useEntityListByField: useInsuranceDataListByField,
  useCreateEntity: useCreateInsuranceData,
  useUpdateEntity: useUpdateInsuranceData,
  usePartialUpdateEntity: usePartialUpdateInsuranceData,
  useDeleteEntity: useDeleteInsuranceData,
} = createCachedEntityHooks<InsuranceData>({
  entityName: "insuranceData",
  service: insuranceDataService,
  enableCacheById: true,
  fieldIndexes: {
    contact_id: () => (contactId) => insuranceDataService.getByContactId(contactId),
  },
  staleTimeMs: 5000,
});

export const useInsuranceDataByContactId = (contactId: number, enabled = true) =>
  useInsuranceDataListByField("contact_id", contactId);

export const useInsuranceDataByContactIds = (contactIds: number[]) =>
  useQuery({
    queryKey: ["insuranceData", "by-contacts", ...contactIds],
    queryFn: () => insuranceDataService.getByContactIds(contactIds),
    enabled: contactIds.length > 0,
  });

export const useInsuranceGroupedByContacts = (contactIds: number[]) =>
  useQuery({
    queryKey: ["insuranceGrouped", ...contactIds],
    queryFn: () => insuranceDataService.getGroupedByContacts(contactIds),
    enabled: contactIds.length > 0,
  });

/**
 * Hook להעלאת קובץ הר הביטוח
 */
export const useSendSingleCoverageEmail = () =>
  useMutation({
    mutationFn: ({ contactId, handlerCode, recipient }: { contactId: number; handlerCode: string; recipient: string }) =>
      insuranceDataService.sendSingleCoverageEmail(contactId, handlerCode, recipient),
  });

export const useUploadHarHabituach = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (file: File) => insuranceDataService.uploadHarHabituachFile(file),
    onSuccess: () => {
      // Invalidate all insurance data queries to refresh the data
      queryClient.invalidateQueries({ queryKey: ["insuranceData"] });
    },
  });
};